import React from 'react';
import { PropTypes } from 'prop-types';
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos } from 'react-icons/md';
import ListOfPages from './ListOfPages';

const Pagination = ({
  itemsPerPage = 20, totalItems, currentPage, setCurrentPage, marginTop = '',
}) => {
  // 20 Rows per page for tables
  const numberOfPages = Math.ceil(totalItems / itemsPerPage);
  // allows to set the margin top of the pagination
  const marginTopValue = marginTop || 'my-20';

  if (numberOfPages <= 1) {
    return null;
  }

  return (
    <div className={`flex justify-center ${marginTopValue}`}>
      <button
        type="button"
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
        className={`flex items-center ${currentPage === 1 && 'cursor-default text-vamos-gray'}`}
      >
        <MdOutlineArrowBackIos className="mr-3" />
        Prev
      </button>
      <ListOfPages numberOfPages={numberOfPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <button
        type="button"
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === numberOfPages}
        className={`flex items-center ${currentPage === numberOfPages && 'cursor-default text-vamos-black'}`}
      >
        Next
        <MdOutlineArrowForwardIos className="ml-3" />
      </button>
    </div>
  );
};

export default Pagination;

Pagination.propTypes = {
  itemsPerPage: PropTypes.number,
  totalItems: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  marginTop: PropTypes.string,
};
